/**
 * Key of new fields without campaign
 */
export const NO_CAMPAIGN_FIELD_KEY = 'no_campaign';
/**
 * error send by pixagri api if a field is subscribe during deletion
 * 
 */
export const CURRENTLY_SUBSCRIBE_ERROR = "At least one active subscription attached"
